<template>
  <a-drawer
    :maskClosable="false"
    width="80%"
    title="打印"
    placement="right"
    :closable="true"
    :visible="visible"
    @close="onClose"
  >
    <div id="myValue">
      <div class="print-box">
        <div class="print-title">销售单</div>
        <div class="print-content">
          <div class="print-content-box">
            <div class="box-item">
              <div class="box-item-title">发货仓库:</div>
              <div class="box-item-text"></div>
            </div>
            <div class="box-item">
              <div class="box-item-title">录单日期:</div>
              <div class="box-item-text">{{ form.createTime ? form.createTime : '' }}</div>
            </div>
            <div class="box-item">
              <div class="box-item-title">单据编号:</div>
              <div class="box-item-text">{{ form.orderNo ? form.orderNo : '' }}</div>
            </div>
          </div>
          <div class="print-content-box">
            <div class="box-item">
              <div class="box-item-title">客户名称:</div>
              <div class="box-item-text">{{ form.shopName ? form.shopName : '' }}</div>
            </div>
            <div class="box-item">
              <div class="box-item-title">联系人:</div>
              <div class="box-item-text">{{ form.receiverName ? form.receiverName : '' }}</div>
            </div>
            <div class="box-item">
              <div class="box-item-title">联系电话:</div>
              <div class="box-item-text">{{ form.shopPhone ? form.shopPhone : '' }}</div>
            </div>
          </div>
          <div class="print-content-box">
            <div class="box-item">
              <div class="box-item-title">联系地址:</div>
              <div class="box-item-text">{{ form.shopAddress ? form.shopAddress : '' }}</div>
            </div>
            <div class="box-item">
              <div class="box-item-title">摘要:</div>
              <div class="box-item-text">{{ form.remarks ? form.remarks : '' }}</div>
            </div>
            <div class="box-item"></div>
          </div>
        </div>
        <div class="print-table">
          <table>
            <tr>
              <th>序号</th>
              <th>商品名称</th>
              <th>单位</th>
              <th>单价</th>
              <th>数量</th>
              <th>折扣</th>
              <th>折后单价</th>
              <th>金额</th>
              <th>备注</th>
            </tr>
            <tr v-for="(item, index) in displayOrderItems" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.prodName }}</td>
              <td>{{ item.unit }}</td>
              <td>{{ item.price }}</td>
              <td>{{ item.prodCount }}</td>
              <td>{{ item.userDiscount }}</td>
              <td>{{ item.actualTotal }}</td>
              <td>{{ item.productTotalAmount }}</td>
              <td>{{ item.remarks }}</td>
            </tr>
            <!-- 第七行：总计大写 -->
            <tr>
              <td>总计大写</td>
              <td colspan="3">{{ totalAmountInWords }}</td>
              <td>{{ form.orderItemList ? form.orderItemList.length : 0 }}</td>
              <td colspan="2">页小计</td>
              <td colspan="2">{{ totalAmount.toFixed(2) }}元</td>
            </tr>

            <!-- 第八行：收款账户 -->
            <tr>
              <td>收款账户</td>
              <td>{{ form.tenantBankCode ? form.tenantBankCode : '0' }}</td>
              <td>收款金额</td>
              <td colspan="3">{{ form.actualTotal ? form.actualTotal : '0' }}元</td>
              <td>优惠金额</td>
              <td colspan="2">{{ form.reduceAmount ? form.reduceAmount : '0' }}</td>
            </tr>
          </table>
        </div>
        <div class="print-content">
          <div class="print-content-box">
            <div class="box-item">
              <div class="box-item-title">制单人:</div>
              <div class="box-item-text">{{ userInfo.nickName }}</div>
            </div>
            <div class="box-item">
              <div class="box-item-title">经手人:</div>
              <div class="box-item-text"></div>
            </div>
            <div class="box-item">
              <div class="box-item-title">打印日期:</div>
              <div class="box-item-text">{{ daytime }}</div>
            </div>
          </div>
        </div>
        <div class="print-remark">
          温馨提示:尊敬的客户，收到货请及时核对产品规格及数量，如有错漏请两天内联系确认，如有不便语谅解，谢谢合作!
        </div>
        <div class="print-content">
          <div class="print-content-box">
            <div class="box-item">
              <div class="box-item-title">公司地址:</div>
              <div class="box-item-text">{{ form.tenantAddress ? form.tenantAddress : '' }}</div>
            </div>
            <div class="box-item">
              <div class="box-item-title">联系电话:</div>
              <div class="box-item-text">{{ form.tenantPhone ? form.tenantPhone : '' }}</div>
            </div>
            <div class="box-item"></div>
          </div>
        </div>
      </div>
    </div>
    <div style="text-align: center">
      <a-button type="primary" @click="onprint">打印</a-button>
    </div>
  </a-drawer>
</template>
<script>
import { getObj } from '@/api/declaration/declarationOrder'
import { getUserProfile } from '@/api/system/user'

import { tableMixin } from '@/store/table-mixin'
export default {
  mixins: [tableMixin],
  name: 'Post',
  data() {
    return {
      visible: false,
      form: {},
      daytime: '',
      errorImage: require('/src/assets/images/defaultImg.png'),
      showPrint: false,
      errorImage: require('/src/assets/images/defaultImg.png'),
      active: 1,
      userInfo: {},
      placeholderImage: '~@/assets/images/defaultImg.png',
      default: 'this.src="' + require('@/assets/images/defaultImg.png') + '"',
    }
  },
  filters: {},
  created() {
    this.type = 1
  },
  computed: {
    hasPermission() {
      return (permission) => {
        if (this.$store.state.user.userTentant.type === 0) {
          return true
        } else {
          return this.$store.state.user.permissions.includes(permission)
        }
        // return true
      }
    },
    // 添加计算属性来计算所有商品的总金额
    totalAmount() {
      if (!this.form.orderItemList || this.form.orderItemList.length === 0) {
        return 0
      }
      // 计算所有item.productTotalAmount的总和
      return this.form.orderItemList.reduce((total, item) => {
        // 确保productTotalAmount是数字类型
        const amount = parseFloat(item.productTotalAmount) || 0
        return total + amount
      }, 0)
    },
    // 添加计算属性来确保至少显示5行记录
    displayOrderItems() {
      const items = this.form.orderItemList || []
      const requiredCount = 5
      // 如果已有记录少于5条，添加空记录补齐
      if (items.length < requiredCount) {
        const emptyItems = Array(requiredCount - items.length).fill({})
        return [...items, ...emptyItems]
      }

      return items
    },
    // 格式化总金额为中文大写金额
    totalAmountInWords() {
      const amount = this.totalAmount
      if (amount === 0) return '零元整'

      // 中文大写数字
      const digits = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
      // 整数部分单位
      const intUnits = ['', '拾', '佰', '仟', '万', '拾', '佰', '仟', '亿', '拾', '佰', '仟']
      // 小数部分单位
      const decimalUnits = ['角', '分']

      // 将金额转换为字符串并分割整数和小数部分
      const amountStr = amount.toFixed(2)
      const [intPart, decimalPart] = amountStr.split('.')

      // 处理整数部分
      let intStr = ''
      const intDigits = intPart.split('').map(Number)

      // 处理前导零
      let zeroFlag = false

      for (let i = 0; i < intDigits.length; i++) {
        const digit = intDigits[i]
        const position = intDigits.length - i - 1

        if (digit === 0) {
          zeroFlag = true
        } else {
          if (zeroFlag && i !== 0) {
            intStr += digits[0]
          }
          intStr += digits[digit] + intUnits[position]
          zeroFlag = false
        }
      }

      // 处理小数部分
      let decimalStr = ''
      const decimalDigits = decimalPart.split('').map(Number)

      if (decimalDigits[0] === 0 && decimalDigits[1] === 0) {
        decimalStr = '整'
      } else {
        if (decimalDigits[0] !== 0) {
          decimalStr += digits[decimalDigits[0]] + decimalUnits[0]
        } else if (decimalDigits[1] !== 0) {
          decimalStr += digits[0]
        }

        if (decimalDigits[1] !== 0) {
          decimalStr += digits[decimalDigits[1]] + decimalUnits[1]
        }
      }

      // 如果整数部分为空，添加'零元'
      if (intStr === '') {
        intStr = '零元'
      } else {
        intStr += '元'
      }

      return intStr + decimalStr
    },
  },

  watch: {},
  methods: {
    formatDate() {
      const date = new Date()
      return new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false, // 使用24小时制
      }).format(date)
    },
    onprint() {
      const myValueElement = document.getElementById('myValue')
      const newstr = myValueElement.innerHTML
      const newWin = window.open('')

      // 创建完整的HTML文档结构
      const htmlContent = `
    <!DOCTYPE html>
    <html>
      <head>
        <title>打印预览</title>
        <style>
          /* 基础打印样式重置 */
          * {
            box-sizing: border-box;
            -webkit-print-color-adjust: exact;
          }
          
          /* 确保在打印时不出现不必要的元素 */
          body {
            margin: 0;
            padding: 20px;
            font-family: SimSun, serif;
            font-size: 12pt;
          }
          
          /* 打印内容容器样式 */
          #myValue {
            width: 100%;
            box-sizing: border-box;
          }
          
          /* 打印盒子样式 */
          .print-box {
            width: 100%;
            height: 100%;
            padding: 20px;
          }
          
          /* 打印标题样式 */
          .print-title {
            font-size: 20px;
            font-weight: bold;
            text-align: center;
            margin-bottom: 20px;
          }
          
          /* 打印内容样式 */
          .print-content {
            width: 100%;
            box-sizing: border-box;
            page-break-inside: avoid;
          }
          
          /* 内容框样式 */
          .print-content-box {
            display: flex;
           justify-content: space-between;
      align-items: center;
          }
          
          /* 框内项目样式 */
          .box-item {
            width: 30%;
            display: flex;
            align-items: center;
            
          }
          
          /* 框内项目标题样式 */
          .box-item-title {
            font-weight: bold;
          }
          
          /* 全宽描述样式 */
          .full-width-descriptions {
            width: 100%;
          }
          
          /* 打印备注样式 */
          .print-remark {
            font-size: 16px;
          }
          
          /* 表格样式 */
          table {
            width: 100%;
            border-collapse: collapse;
            margin: 15px 0;
            page-break-inside: avoid;
          }
          
          /* 表头和单元格样式 */
          th, td {
            border: 1px solid #000 !important;
            padding: 8px;
            text-align: center;
            font-size: 11pt;
          }
          
          /* 表头背景色 */
          th {
            background-color: #f0f0f0 !important;
            -webkit-print-color-adjust: exact;
          }
          
          /* 隐藏打印按钮 */
          .no-print {
            display: none !important;
          }
          
          /* 打印特定样式 */
          @media print {
            /* 确保页面边距合适 */
            @page {
              margin: 1cm;
              size: A4 landscape;
            }
            
            /* 确保元素不被分割 */
            #myValue, .print-content, table {
              page-break-inside: avoid;
            }
            
            /* 确保边框在打印时显示 */
            table, th, td {
              border: 1px solid #000 !important;
              border-collapse: collapse !important;
            }
            
            /* 确保背景色在打印时显示 */
            th {
              background-color: #f0f0f0 !important;
              -webkit-print-color-adjust: exact;
            }
            
            /* 隐藏不应该打印的元素 */
            .no-print {
              display: none !important;
            }
          }
        </style>
      </head>
      <body>
        <div id="myValue">
          ${newstr}
        </div>
      </body>
    </html>
  `

      // 将完整的HTML内容写入新窗口
      newWin.document.write(htmlContent)
      newWin.document.close()
      newWin.focus()

      // 延迟打印以确保样式正确加载
      setTimeout(() => {
        newWin.print()
        newWin.close()
      }, 300)
    },

    handleLook(e) {
      window.open(e)
    },
    init(e, index) {
      this.isBack = false
      getObj(e.orderId).then((res) => {
        this.form = res.data
        this.dataForm = e
        // this.active = index
        this.visible = true
      })
      getUserProfile().then((response) => {
        this.userInfo = response.data
      })
      this.daytime = this.formatDate()
    },

    onClose() {
      const that = this
      that.visible = false
    },
  },
}
</script>
<style lang="less" scoped>
.print-box {
  width: 100%;
  height: 100%;
  padding: 20px;
  .print-title {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
  }
  .print-content {
    .print-content-box {
      display: flex;
      // justify-content: space-between;
      justify-content: space-between;
      align-items: center;
      .box-item {
        width: 30%;
        display: flex;
        align-items: center;
        .box-item-title {
        }
        .box-item-text {
        }
      }
    }
  }
  .full-width-descriptions {
    width: 100%;
  }
  .print-remark {
    font-size: 16px;
  }
  table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
  }
  th,
  td {
    border: 1px solid #000;
    padding: 8px;
    text-align: center;
  }
  th {
    background-color: #f0f0f0;
  }
}
</style>
